import ApiClient from '../client';
const path = require('path');

class LoginAPI extends ApiClient {

  constructor() {
    super();
  }

  async getUserLogin() {
    try {
      const response = await this.get(this.LOGIN_API_PATH);
      if (response.status === 200) {
        return response.data;
      }
    }
    catch (err) {
      if (err.response && err.response.data.code && err.response.data.code === 'terms-required') {
        window.location.href = `${process.env.VUE_APP_LOGIN_TERMS_ROUTE}?next=${window.location.pathname}${window.location.hash}`;
      }
      return false;
    }
  }

  async userLogout() {
    const url = path.join(
      this.USER_LOGIN_API_PATH,
      '/signout'
    );
    const response = await this.get(url);
    return response.data;
  }

};

const loginAPI = new LoginAPI();
export default loginAPI;
